import React, { useState } from "react";
import s from "./ScreenPositionModal.module.css";
import closeImg from "../../../../assets/images/common/icons/close.svg";
import { getCookie } from "../../../utils";

const ScreenPositionModal = (props) => {
  const isDisabled = getCookie("SPM_disabled") !== undefined;
  const [close, setClose] = useState(isDisabled); // for rerender on change
  const saveClose = () => {
    document.cookie = `SPM_disabled=true;path=/;max-age=${60 * 60 * 24}`;
  };

  return (
    !isDisabled && (
      <div className={s.background}>
        <div className={s.container}>
          <img
            src={closeImg}
            alt={"close"}
            onClick={() => {
              setClose(true);
              saveClose();
            }}
          />
          <p>Please rotate your device to landscape mode for a better experience</p>
        </div>
      </div>
    )
  );
};

export default ScreenPositionModal;
